export default {
  GNB_PRODUCT: "서비스 소개",
  GNB_PRICING: "가격 안내",
  GNB_DEVELOPERS: "개발 가이드",
  GNB_COMPANY: "Company",
  GNB_BLOG: "블로그",
  BTN_APPLY_PROGRAM: "무료로 신청하기(선착순)",
  BTN_START_ABTEST: "무료 체험 시작하기",
  BTN_CTA_A: "무료체험 시작하기",
  BTN_CTA_B: "둘러보기",
  BTN_CTA_C: "A/B 테스트 시작하기",
  BTN_REQUEST_DEMO: "초보자용 데모 신청하기",
  BTN_REQUEST_DEMO_FOR_FREE: "무료 데모 요청",
  BTN_REQUEST: "신청하기",
  BTN_READ_MORE: "더 알아보기",
  HACK_THE_PRODUCT_TITLE: "A/B 테스트 교육 프로그램 접수 중",
  HACK_THE_PRODUCT_DESC1: "A/B 테스트를 통해 데이터 분석을 시작하세요!",
  HACK_THE_PRODUCT_DESC2: "수년간의 A/B 테스트 경험이 있는 핵클팀이 도입 시작부터 끝까지 모두 도와드립니다.",
  TITLE_PROVE_DATA: "Prove all product changes with data",
  PRODUCT_DECISION_TITLE: "실험을 통한 정량적인 의사결정",
  PRODUCT_DECISION_DESC1: "원하는 모든 성과지표를",
  PRODUCT_DECISION_DESC2: "만들고 측정할 수 있습니다.",
  EASY_INTEGRATION_TITLE: "SDK를 통한 간단한 개발 연동",
  EASY_INTEGRATION_DESC: "Server / Client-side SDK를 모두 지원합니다.",
  EASY_INTEGRATION_BTN: "SDK 연동 가이드 문서 보러가기",
  REDUCE_RISK_TITLE: "빠르고 효과적인 제품 개발",
  REDUCE_RISK_DESC1: "새로운 아이디어를 빠르게 테스트하고, ",
  REDUCE_RISK_DESC2: "더 나은 성과를 보여주는 것들만 적용합니다.",
  DATA_ANALYTICS_TITLE: "A/B 테스트 전문가들이 만든 실험 플랫폼",
  DATA_ANALYTICS_DESC1: "합리적인 가격으로 ",
  DATA_ANALYTICS_DESC2: "국내 유일의 A/B 테스트 플랫폼을 이용해보세요.",
  ABOUT_TITLE1: "핵클과 함께 ",
  ABOUT_TITLE2: "A/B테스트를 시작해보세요!",
  ABOUT_BTN_SLACK: "슬랙으로 물어보기",
  COMPARISON_A_COMPANY: "타사A",
  COMPARISON_A_PRICE: "연 4,000만 원~",
  COMPARISON_B_COMPANY: "타사B",
  COMPARISON_B_PRICE: "연 2,640만 원~",
  COMPARISON_HACKLE_PRICE: "무료 체험 중",
  FOOTER_PRODUCT: "서비스",
  FOOTER_AB_TESTING: "A/B 테스트",
  FOOTER_FUNNEL: "사용자 퍼널 분석",
  FOOTER_PRICING: "가격 안내",
  SERVICE_GUIDE: "서비스 가이드",
  FOOTER_SDK: "SDK 연동 가이드",
  FOOTER_USER_MANUAL: "사용자 가이드",
  FOOTER_FAQ: "자주 묻는 질문",
  FOOTER_COMPANY: "회사",
  FOOTER_ABOUT: "회사 소개",
  FOOTER_CAREERS: "채용 안내",
  FOOTER_BLOG: "블로그",
  FOOTER_EMAIL: "문의",
  POLICY_TERMS_OF_SERVICE: "서비스 이용약관",
  POLICY_PRIVACY: "개인정보 처리방침",
  POLICY_COOKIE: "쿠키 정책",
  REQUIRED_EMAIL: "이메일 (필수)",
  EMAIL: "이메일",
  NAME: "이름",
  PHONE_NUMBER: "연락처",
  REQUEST_DEMO_COMMENT: "문의하실 내용을 자유롭게 기재해주세요.",
  REQUEST_DEMO_TITLE: "상담 신청하기",
  REQUEST_DEMO_DESC: "A/B 테스트와 데이터를 이용하여 제품을 어떻게 개선하는지 알아보세요",
  REQUESTED_DEMO_TITLE: "Demo 신청이 완료되었습니다.",
  REQUESTED_DEMO_DESC1: "핵클 A/B 테스트 플랫폼 안내를 위해, ",
  REQUESTED_DEMO_DESC2: "담당자가 빠르게 확인하여 연락을 드리도록 하겠습니다.",
  REQUESTED_DEMO_READ_MORE1: "A/B 테스트에 대한 ",
  REQUESTED_DEMO_READ_MORE2: "인사이트를 얻을 수 있는",
  REQUESTED_DEMO_READ_MORE3: " 핵클 블로그를 확인해보세요.",
  BLOG_HACKLE_DESC: "핵클의 공동창업자가 A/B 테스트가 스타트업에 필요한 이유를 설명합니다.",
  BLOG_NETFLIX_DESC: "넷플릭스가 A/B 테스트를 통해 넷플릭스 영상에 가장 적합한 삽화를 찾는 방법을 소개합니다.",
  BLOG_GRAB_DESC: "그랩은 A/B 테스트를 통해 드라이버의 참여도를 높이면서 건강한 성장을 유지하게 됩니다.",
  SUBMIT_AGREE_POLICY: "이 양식을 제출하면 {service}, {private} 및 {cookie}에 따르는 것에 동의합니다.",
  ab_test: "A/B 테스트",
  feature_flag: "기능 플래그",
  funnel: "사용자 퍼널 분석",
  funnel_start_btn: "사용자 퍼널 분석 시작하기",
  btn_feature_flag_start: "기능 관리 시작하기",
  service_description_feature_flag1: "장애 리스크를 줄이고 원하는 시점에",
  service_description_feature_flag2: "안전하게 기능을 출시하세요",
  search_more_btn: "더 알아보기",
  AB_TEST_SEARCH_MORE: "A/B 테스트 더 알아보기",
  COMPARE_PRICE: "가격 및 기능 비교하기",
  FOOTER_SUPPORT: "고객지원",
  BTN_START_FUNNEL: "사용자 퍼널 분석 시작하기",
  btn_ab_test_hero_section: "A/B 테스트 시작하기",
  btn_funnel_hero_section: "사용자 퍼널 분석 시작하기",
  btn_feature_flag_hero_section: "기능 관리 시작하기",
  plan_name_1: "스타트업 무료 플랜",
  plan_name_2: "프로 플랜",
  plan_name_3: "엔터프라이즈 플랜",
  btn_start_free: "무료로 시작하기",
  inquire: "문의하기",
  free_plan: "스타트업 무료 플랜",
  free_plan_desc: "월 100,000개 이벤트까지",
  btn_start_free_plan: "무료로 시작하기",
  basic_rate: `기본료 {amount}원`,
  per_event: `이벤트 당 {amount}원`,
  pro_plan: "프로 플랜",
  enterprise_plan: "엔터프라이즈 플랜",
  contact_us_separately: "별도 문의",
  btn_inquire: "문의하기",
  plan_benefit_many_kinds_of_sdk: "10가지 종류의 SDK 제공",
  plan_benefit_test_platform_line1: "웹, 모바일 앱, 서버 기반",
  plan_benefit_test_platform_line2: "A/B 테스트, 기능 플래그 가능",
  plan_benefit_change_real_time_line1: "A/B 테스트, 기능 플래그",
  plan_benefit_change_real_time_line2: "변경 사항 실시간 적용",
  pro_plan_benefit_contain_free_plan: "무료 플랜 기능 모두 제공",
  pro_plan_benefit_free_trial_period: "14일 무료 체험 기간 제공",
  pro_plan_benefit_segment: "데이터 상세 분석 가능",
  pro_plan_benefit_segment_sample: "(OS,언어,지역 등)",
  pro_plan_benefit_webinar: "웨비나, 오프라인 교육 우선권 제공",
  pro_plan_benefit_technical_support: "Slack을 통한 기술 지원",
  enterprise_plan_benefit_contain_pro_plan: "프로 플랜 혜택 모두 제공",
  enterprise_plan_benefit_tailored_training: "기업 맞춤형 교육 세션 제공",
  enterprise_plan_benefit_raw_data_and_analysis_consulting_line1: "Raw data 추출 및 데이터 분석",
  enterprise_plan_benefit_raw_data_and_analysis_consulting_line2: "컨설팅 제공",
  enterprise_plan_benefit_monitoring: "알람 및 모니터링 지원",
  enterprise_plan_benefit_SLA: "SLA 기반의 전담 지원",
  feature_flag_launch_event_title: "기능 플래그 출시 이벤트!",
  feature_flag_launch_event_desc: "이벤트 기간동안 플랜 상관없이 무제한 사용 가능! ({date}까지)",
  event_tooltip:
    "이벤트는 웹/앱 서비스 이용자가 플랫폼상에서 취하는 행동으로 발생하는 모든 사건입니다. 모든 사용자 행동 (예시: 버튼 클릭, 페이지 진입, 구매 완료 등)과 A/B 테스트 혹은 기능플래그 사용자 분배가 해당됩니다.",
  collaborator_limit_free: "인원 최대 3명까지",
  collaborator_limit_pro: "인원 최대 10명까지",
  select_msg_free_plan: "스타트업 무료 플랜이 등록되었습니다.",
  select_msg_pro_plan: "프로 플랜이 등록되었습니다.",
  data_archiving_limit_free_plan: "데이터 보관 기간 2개월",
  data_archiving_limit_pro_plan: "데이터 보관 기간 6개월",
  email_support: "1 영업일 내 이메일 지원",
  pro_plan_desc: "사용량 무제한",
  payment_basic: "기본료",
  payment_event: "이벤트 당",
  enterprise_plan_benefit1: "인원 무제한",
  enterprise_plan_benefit2: "Data Export 제공",
  enterprise_plan_benefit3: "SSO 및 인증 지원",
  enterprise_plan_benefit4: "데이터 보관 기간 12개월",
  enterprise_plan_benefit5: "SLA 기반의 전담 지원",
  plan_overcharge_desc:
    "*프로 플랜을 초과하는 사용량에 대한 이벤트당 이용 요금은 프로모션 적용 이전 기준으로 계산되어 청구됩니다.",
  plan_tax_desc: "*부가가치세 별도",
  free_charge: "무료 제공",
  funnel_promotion_1: "출시 프로모션 기간동안 플랜 상관없이",
  funnel_promotion_2: "무제한 사용 가능!",
  promotion_time_limit: "출시 프로모션! {date}까지",
  pro_plan_include_free_plan: "스타트업 플랜의 모든 기능 제공",
  plan_benefit_targeting: "사용자 타겟팅 기능 제공",
  enterprise_plan_include_pro_plan: "프로 플랜의 모든 기능 제공",
  btn_integration_guide: "연동 가이드 보기",
  sdk_integration: "SDK 연동",
  sdk_integration_title_line1: "웹, 앱, 서버 상관없이",
  sdk_integration_title_line2: "5분이면 사용 가능",
  preview_video: "영상으로 미리보기",
  anomaly_detection: "이상 징후 모니터링",
  anomaly_detection_line1: "모니터링 알림으로",
  anomaly_detection_line2: "이슈를 빠르게 확인하세요",
  release_notifications: "출시 알림 받기",
  release_notifications_modal_title: "출시 알림 신청하기",
  request_release_notification_comment: "문의하실 내용을 자유롭게 기재해주세요.",
  data_insight: "데이터 인사이트",
  data_analytics: "데이터 분석",
  pro_plan_usage_limit: "*월 5,000,000건 초과시 이벤트당 0.2원",
  pro_plan_benefit_metric_type: "모든 유형의 지표 설정 등",
  pro_plan_benefit_detail_line1: "(사용자 타겟팅, 세그먼트 분석,",
  pro_plan_benefit_detail_line2: "모니터링 알람, 모든 유형의 지표 설정 등)",
  sign_in: "로그인",
  cta_tour: "서비스 둘러보기",
  gnb_tour: "서비스 둘러보기",
  pricing_calculator_title: "예상 금액을 미리 알아보세요",
  pricing_calculator_business_type_commerce: "커머스",
  pricing_calculator_business_type_social_media: "소셜 미디어",
  pricing_calculator_business_type_education: "교육",
  pricing_calculator_business_type_others: "기타",
  pricing_calculator_category: "카테고리",
  pricing_calculator_mau: "월 방문 사용자 수 (MAU)",
  pricing_calculator_expected_usage: "예상 이벤트 사용량",
  pricing_calculator_recommended_plan: "추천 플랜",
  pricing_calculator_estimated_monthly_price: "월 예상 금액",
  pricing_calculator_notice:
    "* 이해를 돕기위한 업종별 평균 예상 금액이며, 실제 금액은 A/B 테스트 및 기능 플래그 분배, 행동 이벤트 발생량에 따라 달라질 수 있습니다.",
  service_sdk_integration_title: "SDK 연동까지 단 5분!",
  service_sdk_integration_desc_1: "웹과 앱 모두 사용 가능한 Server, Client-side SDK를 지원하여",
  service_sdk_integration_desc_2: "다양한 환경에서 핵클 서비스를 사용하실 수 있습니다.",
  DEVELOPERS_GUIDE: "개발자 가이드",
  GNB_GUIDES: "가이드",
  CTA_ANALYTICS: "데이터 분석 시작하기",
  analytics_detail_page_data_insight_title: "몇 번의 클릭으로 사용자 행동 분석을 손쉽게!",
  analytics_detail_page_data_insight_desc_line1: "몇 번의 클릭으로 사용자 행동 로그를 시각화하여 분석할 수 있습니다.",
  analytics_detail_page_data_insight_desc_line2:
    "사용자 유입, 전환율, 비즈니스 KPI 추이 등 고객의 제품 이용현황을 파악할 수 있습니다.",
  analytics_detail_page_summary_1: "유입/방문, 전환율, KPI 등 다양한 분석 가능",
  analytics_detail_page_summary_2: "데이터 샘플링 없이 정확한 결과",
  analytics_detail_page_summary_3: "저장한 차트들을 한 화면에서 한눈에 확인",
  event_management: "이벤트 관리",
  event_management_real_time: "이벤트 실시간 상태 조회 및 추이 분석",
  event_management_automatic: "이벤트 세부 속성 자동 수집 지원",
  except_automatic_event: "이벤트 자동 수집 제외",
  event_management_image: "예시 이미지 등록으로 손쉬운 이벤트 설명",
  analytics_summary_use_case_title: "유입/방문, 전환율, KPI 등 다양한 분석 가능",
  analytics_summary_without_sampling_title: "데이터 샘플링 없이 정확한 결과",
  analytics_summary_save_chart_title: "저장한 차트들을 한 화면에서 한눈에 확인",
  analytics_summary_use_case_desc: "계산 유형에 OS, 경로, 지역 등 다양한 필터를 적용할 수 있습니다.",
  analytics_summary_without_sampling_desc: "실제 수집된 데이터로만 계산하여 결과를 더 신뢰할 수 있습니다.",
  analytics_summary_save_chart_desc: "자동 업데이트 된 차트를 한 화면에서 확인할 수 있습니다.",
  home_data_insight_description:
    "검색 버튼 클릭, 상품 페이지 진입, 구매완료 등 확인하고 싶은 지표를 분석항목으로 설정하여 다양한 데이터 분석을 할 수 있습니다.",
  home_retention_description_line1: "리텐션은 제품의 성공 지표 그 자체입니다.",
  home_retention_description_line2: "다양한 조건으로 사용자의 재사용 패턴을 깊이있게 파악해보세요.",
}
